<app-form-field [required]="true">
  <label class="!text-[14px]" app-label translate>trilhas.estudio.trilha.anexo-principal</label>
  <app-upload-file
    *ngIf="!form.value.hash && !form.value.file; else file"
    class="w-full"
    [config]="config"
    [invalid]="submitted && form.controls.file.invalid"
    (statusChange)="onUpload($event)"
  ></app-upload-file>
  <span app-error *ngIf="submitted && form.controls.file.invalid" translate>geral.erros.required</span>
</app-form-field>

<ng-template #file>
  <div class="flex w-full">
    <audio controls class="w-full">
      <source [src]="preview" type="audio/mpeg" />
      {{ 'geral.alertas.erro-operacao' | translate }}
    </audio>
    <button (click)="onDelete()" app-flat-button type="button" class="ml-2 w-16 bg-red-500">
      <svg-icon class="w-6 text-white" src="assets/icons/icon-trash.svg"></svg-icon>
    </button>
  </div>
</ng-template>
